var map = {
	"./project-alert-icon.svg": "f65q",
	"./project-analyzing-icon.svg": "C9pW",
	"./project-completed-icon.svg": "LNx3",
	"./project-failed-icon.svg": "Vse0",
	"./project-list-icon.svg": "V8N6",
	"./project-started-icon.svg": "kz4M"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MVOO";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/project\-.*\-icon\.svg$
// module id = MVOO
// module chunks = 26